import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Textarea,
} from "@shortsworks/ui";
import { FormItemProps } from "@app/components/forms/types/props";
import { cn } from "@shortsworks/ui/lib/utils";
import { TextInputSchema } from "@app/components/forms/types/schema";

export const FormTextarea = ({
  form,
  schema,
  ...rest
}: FormItemProps<TextInputSchema>) => {
  return (
    <FormField
      control={form.control}
      name={schema.id}
      render={({ field }: any) => (
        <FormItem
          className={cn(
            schema.appearance?.className,
            schema.appearance?.border ? "border p-4 rounded-md" : "",
          )}
        >
          <FormLabel>
            {typeof schema.label === "function"
              ? schema.label(form.getValues())
              : schema.label}
          </FormLabel>
          <FormControl>
            <Textarea
              placeholder={schema.placeholder}
              {...field}
              {...schema.behavior}
            />
          </FormControl>
          {schema.description && (
            <FormDescription>
              {typeof schema.description === "function"
                ? schema.description(form.getValues())
                : schema.description}
            </FormDescription>
          )}
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
